import { InputAnimatedLabel } from "@web/components/ui/input-animated-label";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@web/components/ui/dropdown-menu";
import { ChevronDownIcon } from "lucide-react";

type DoctorStatusDropdownProps = {
  value?: string;
  readOnly?: boolean;
  onSelect: (status: "active" | "inactive" | "on-leave" | "retired") => void;
};

export function DoctorStatusDropdown({
  value,
  readOnly = true,
  onSelect
}: DoctorStatusDropdownProps) {
  const statusOptions: ("active" | "inactive" | "on-leave" | "retired")[] = [
    'active', 'inactive', 'on-leave', 'retired'
  ];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={readOnly}>
        <div className="relative w-full">
          <InputAnimatedLabel
            label="Status"
            value={value ?? ''}
            readOnly={true}
            className={readOnly ? "" : "border-blue-500 border-2"}
          />
          {!readOnly && (
            <ChevronDownIcon className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500" />
          )}
        </div>
      </DropdownMenuTrigger>
      {!readOnly && (
        <DropdownMenuContent className="bg-white shadow-lg rounded-lg border">
          {statusOptions.map((status) => (
            <DropdownMenuItem
              key={status}
              onSelect={() => { onSelect(status) }}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
            >
              {status}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      )}
    </DropdownMenu>
  );
}